import PageHeaderLayout from '../shared/components/PageHeaderLayout';
import withSysUtilsFeatureFlagCheck from '../shared/hoc/withSysUtilsFeatureFlagCheck';
import ImportSalesOrder from './components/ImportSalesOrder';

const pageConfig = {
  header: 'Sales Utilities',
  description:
    'These utilities can be used to manage and import sales orders from external sources into the platform.',
};

const InvoiceUtils = () => {
  return (
    <PageHeaderLayout pageConfig={pageConfig}>
      <ImportSalesOrder />
    </PageHeaderLayout>
  );
};

export default withSysUtilsFeatureFlagCheck(InvoiceUtils);
